<template>
  <div class="approval-approver-search w-100">
    <DpplTreeselect
      :model-value="modelValue"
      async
      :async-url="asyncUrl"
      label=""
      search-appearance="inline"
      placeholder="Search"
      :show-select-all="false"
      :max-height="200"
      id-key="id"
      label-key="label"
      @update:model-value="$emit('update:modelValue', $event)"
      @add-snackbar="addErrorSnackbar"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import DpplTreeselect from '@/components/datapeople/DpplTreeselect.vue';
import { useAppAuthData } from '@/stores/app/authData';
import { useAppSnackbar } from '@/stores/app/snackbar';

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  excludeIds: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['update:modelValue']);

const { authData } = storeToRefs(useAppAuthData());
const { addErrorSnackbar } = useAppSnackbar();

const asyncUrl = computed(() => {
  const params = {
    project_id: authData.value.projectId,
  };

  if (props.excludeIds.length) {
    params.exclude_ulids = props.excludeIds.join(',');
  }

  return {
    path: '/vue/lookup-job-profile-approver',
    params,
  };
});
</script>

<style scoped lang="less">
.approval-approver-search {
  :deep(.label-row) {
    display: none;
  }

  :deep(.actions.pr-4) {
    padding-right: 0 !important;
    width: 100%;
  }

  :deep(.tree-item-action:hover) {
    background: rgba(@icon-brand, .05);
  }

  :deep(input[type=checkbox]) {
    min-width: 15px;
    min-height: 15px;
    width: 15px;
    height: 15px;

    &::before {
      left: 4px;
      width: 5px;
      height: 9px;
    }
  }

  :deep(label) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    color: @text-light;
  }
}
</style>
